import React from "react";
import slideStyle from "./InfoPage.module.scss";
import Badge from "../components/Badge/Badge";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { useContext } from "react";
import { MessageContext, Message, getMessage } from "@messageformat/react";

const SafePOS = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.safePOS.subtitle" />}
        title={<Message id="infoPages.safePOS.title" />}
        hints={[
          <Message id="infoPages.safePOS.hints.hint1" />,
          <Message id="infoPages.safePOS.hints.hint2" />,
          <Message id="infoPages.safePOS.hints.hint3" />,
        ]}
      />
      <div className={slideStyle.section}>
        <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "infoPages.safePOS.description")() }} />

        <ContactAppendix />
      </div>
    </>
  );
};

export default SafePOS;
